import { Component, Input, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
// import * as esri from 'esri-leaflet';
import * as L from 'leaflet';

@Component({
  selector: 'app-mapa-colonias',
  templateUrl: './mapa-colonias.component.html',
  styleUrls: ['./mapa-colonias.component.scss']
})
export class MapaColoniasComponent implements OnInit, AfterViewInit {
  map: any;

  @Input() colonias: any;

  @ViewChild('primaryMap', {static: true}) protected mapDivRef: ElementRef;
  protected mapDiv: HTMLDivElement;

  constructor() { }

  ngOnInit(): void {
    this.mapDiv = this.mapDivRef.nativeElement;
  }

  ngAfterViewInit() {
    const myAPIKey = "0162482e691040afa6ac3cbfc6dbc92d";
    const mapStyle = "https://maps.geoapify.com/v1/styles/osm-carto/style.json";

   this.map = L.map('map', { scrollWheelZoom: false }).setView([19.369903, -99.148074], 11);

   L.tileLayer('http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
			maxZoom: 16,
			minZoom: 10,
		}).addTo(this.map);

    this.colonias.filters.map((el) => {
      if (el["geo_shape"] && el["geo_shape"] != "NA") {
        L.geoJSON(JSON.parse(el["geo_shape"]), {
          style: {
            "color": "#fff",
            "fillColor": "#4F5D9F",
            "weight": 1,
            "fillOpacity": el.total / 100
          },
        }).addTo(this.map);
      }
    });

    let info = new L.Control({ position: "bottomright" });

    info.onAdd = function (map) {
      this._div = L.DomUtil.create('div', 'info'); // create a div with a class "info"
      this._div.innerHTML = `
        <h4>Índice de casos activos por colonia</h4>
      `;

      let grades: any = [
        { "color": "#BFC5DA", "quintil": "1,0", "max": "1,8" },
        { "color": "#9AA2C6", "quintil": "1,9", "max": "2,6" },
        { "color": "#747FB3", "quintil": "2,7", "max": "3,4" },
        { "color": "#4F5D9F", "quintil": "3,5", "max": "4,2" },
        { "color": "#293B8D", "quintil": "4,3", "max": "5,0" },
        { "color": "#97BAD5", "quintil": "quintil no definido", "max": "" },
        { "color": "#AAAAAA", "quintil": "quintil fuera del límite", "max": "" },
      ];

      grades.map((grade) => {
        this._inner = L.DomUtil.create('div', 'list');
        this._inner.innerHTML = `
          <div class="clearfix">
            <div class="square" style="background-color: ${grade.color}"></div>
            <div style="float:left; margin-left: 6px; width: 80%;">${grade.quintil} -> ${grade.max ? grade.max : ""}</div>
          </div>
        `;
        this._div.append(this._inner)
      });

      return this._div;
    };

    /*info.update = function (props) {
      let grades: any = [
        { "color": "#BFC5DA", "quintil": "1,0", "max": "1,8" },
        { "color": "#9AA2C6", "quintil": "1,9", "max": "2,6" },
        { "color": "#747FB3", "quintil": "2,7", "max": "3,4" },
        { "color": "#4F5D9F", "quintil": "3,5", "max": "4,2" },
        { "color": "#293B8D", "quintil": "4,3", "max": "5,0" },
        { "color": "#97BAD5", "quintil": "quintil no definido", "max": "" },
        { "color": "#AAAAAA", "quintil": "quintil fuera del límite", "max": "" },
      ];

      console.log("div => ", this._div)

      grades.map((grade) => {
        this._inner = L.DomUtil.create('div', 'list');
        this._inner.innerHTML = `
          <div class="clearfix">
            <div class="square" style="background-color: ${grade.color}"></div>
            <div style="float:left; margin-left: 6px; width: 80%;">${grade.quintil} -> ${grade.max ? grade.max : ""}</div>
          </div>
        `;
        this._div.append(this._inner)
      });
    };*/

    info.addTo(this.map);

    function colorlayer(feature, layer) {
      layer.on('mouseover', function (e) {
          layer.setStyle({
              fillOpacity: 0.4
          });
      });
      layer.on('mouseout', function (e) {
          layer.setStyle({
              fillOpacity: 0
          });
      });
    }
  }
}
